import { Isbot } from './isbot/index.js'

const isbot = new Isbot()

export default isbot
export { isbot }
